<template>
  <b-row>
    <b-col cols="12">
      <transition name="slide">
        <b-card>
          <div slot="header">
            <i class="fa fa-users"></i> Usuarios
         <!--   <router-link
              class="pull-right btn btn-sm btn-success text-white"
              to="/register"
            >
              <i class="fa fa-plus" /> Nuevo Usuario
            </router-link> -->
          </div>
          <em class="text-info"
            ><strong
              ><span class="text-dark">*</span> Click en la fila si desea editar
              un usuario</strong
            ></em
          >
          <b-table
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
          >
            <template #cell(nombre)="data">
              {{ data.item.nombre }}
            </template>
            <template #cell(username)="data">
              {{ data.item.username }}
            </template>
            <template #cell(rol_nombre)="data">
              {{ data.item.rol_nombre }}
            </template>
            <template #cell(email)="data">
              {{ data.item.email }}
            </template>
            <template #cell(activo)="data">
              <span style="width:80%;" v-show="data.item.activo == '1'"
                >Si</span
              >
              <span style="width:80%" v-show="data.item.activo == '0'">No</span>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="getRowCount(items)"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Ant"
              next-text="Sig"
              hide-goto-end-buttons
            />
          </nav>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
//import usersData from './UsersData'
export default {
  name: "Users",
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getUsers();
  },
  data: () => {
    return {
      items: [],
      fields: [
        { label: "Usuario", key: "username" },
        { key: "nombre" },
        { label:"Rol", key: "rol_nombre" },
        { key: "email" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    };
  },
  computed: {},
  methods: {
    async getUsers() {
      // eslint-disable-next-line no-undef
     let req = await axios.get("/api/usuarios");
    this.items = req.data;

    },
    getRowCount(items) {
      return items.length;
    },
    userLink(id) {
      return `users/${id.toString()}`;
    },
    rowClicked(item) {
      const userLink = this.userLink(item.id);
      this.$router.push({ path: userLink });
    }
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
